import { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '@reducers/index';
import { dispatchGroupHandler } from '@reducers/keyword/keywordSuggestionSlice';
import { KeywordResearch } from '@classes/options/grid/keyword/keywordSuggestion';
import { fetchKeywordAddDel, fetchTabKeywordGridData } from '@reducers/keyword/thunk/suggestionThunk';
import { gridOptionModel } from '@models/gridModel';
import { IResultKeywordType } from '@models/keyword/keywordModel';
import GridAtom from '@components/atom/grid/grid';
import NoData from '@components/atom/noData';
import { tabInfoDataFrame } from '@configs/keyword'; //이건 리덕스에서 넣기
import { FadeLoader } from 'react-spinners';

type changeObjType = {
  keyword;
  group;
  keywordObj?: any;
};

const ResultKeywordsBox = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { keywordGroupList } = useSelector(({ keyword }: RootState) => keyword);
  const { tabKeywordList, tabInfoData, registerdKeywordList } = useSelector(
    ({ keywordSuggestion }: RootState) => keywordSuggestion
  );

  const [gridData, setGridData] = useState<gridOptionModel<IResultKeywordType>>(null);
  const [changeGridObj, setChangeGridObj] = useState<changeObjType>(null);
  const [selectedTab, setSelectedTab] = useState(null);

  const gridOption = new KeywordResearch();

  // // useEffect initialData for gridChart
  // useEffect(() => {
  //   if (tabKeywordList && keywordGroupList) {
  //     setGridData(gridOption.resultOption(tabKeywordList, keywordGroupList, groupHandler, addDelHandler));
  //   }
  // }, [tabKeywordList]);

  useEffect(() => {
    if (gridData) {
      console.log('gridData: ', gridData);
    }
  }, [gridData]);

  // useEffect changeObj
  useEffect(() => {
    if (gridData) {
      if (changeGridObj) {
        const { data } = gridData;
        const { keyword, group, keywordObj } = changeGridObj;
        // add/del 요청 시 dispatch로 서버에 요청 후 redux 에 적용하기
        if (keywordObj) {
          if (selectedTab) {
            // 여기서 탭정보까지 넣어서 fetch로 전달 후 slice 에서 처리하기
            const { text: tabText, index: tabIndex } = selectedTab;
            const dataIndex = gridData?.data.findIndex((gridItem) => gridItem.keyword === keywordObj?.keyword);
            const updatedData = { ...keywordObj, tracked: !keywordObj?.tracked };
            console.log('updatedData: ', updatedData);
            const startList = gridData?.data.slice(0, dataIndex);
            const lastList = gridData?.data.slice(dataIndex + 1, gridData?.data.length);
            setGridData(
              gridOption.resultOption(
                startList.concat(updatedData).concat(lastList),
                // .filter((item, index) => index - 1 !== dataIndex)
                registerdKeywordList,
                keywordGroupList,
                groupHandler,
                addDelHandler,
                tabIndex
              )
            );
          }
        } else {
          // 그룹선택은 현재 gridData 만 변경처리하기
          if (selectedTab) {
            const { text: tabText, index: tabIndex } = selectedTab;
            const arrIndex = data.findIndex((item) => item.keyword === keyword);
            // redux의 requestKeywordList에 추가하기!! 조건문으로 나눠서 add/ del 처리하기
            // // group 만 바꾸면 아래와 같이 바꿈처리하기
            const _data = JSON.parse(JSON.stringify(data));
            _data[arrIndex].group = group;
            // 기존데이터랑 차트에서 가져온 데이터랑 구분해서 작업할것..
            setGridData(
              gridOption.resultOption(
                _data,
                registerdKeywordList,
                keywordGroupList,
                groupHandler,
                addDelHandler,
                tabIndex
              )
            );
          }
        }
      }
    }
  }, [changeGridObj]);

  // 그룹 변경 핸들러 (현재 grid 차트에서만 변경처리할 것)
  const groupHandler = useCallback((event, keyword) => {
    console.log('event, keyword: ', event, keyword);
    const { value } = event.target;
    setChangeGridObj({ keyword: keyword, group: value });
    // setGridData((prev) => {
    //   console.log('prev: ', prev);
    //   const dataIndex = prev.data.findIndex((item) => item.keyword === keyword);
    //   console.log('dataIndex: ', dataIndex);
    //   const updatedData = { ...prev.data[dataIndex], group: value };
    //   console.log('updatedData: ', updatedData);
    //   const startList = prev.data.slice(0, dataIndex);
    //   const lastList = prev.data.slice(dataIndex, prev.data.length);
    //   return {
    //     ...prev,
    //     data: startList
    //       .concat(updatedData)
    //       .concat(lastList)
    //       .filter((item, index) => index !== dataIndex),
    //   };
    // });
  }, []);

  const addDelHandler = useCallback(
    (currentTabIndex, keywordObj) => {
      // // 여기서 말고 changeObj 바꾸고 위의 useEffect 에서 변경처리하기..
      // // 아래의 dispatch 는 useEffect 에서 처리하기.. 클로저 문제 + tab 까지 넘겨서 처리해야한다.
      // setChangeGridObj({
      //   keyword: keyword,
      //   reqType: currentTracked ? 'del' : 'add',
      //   group: group,
      // });
      console.log('keywordObj: ', keywordObj);
      console.log('currentTabIndex: ', currentTabIndex);
      console.log('gridData: ', gridData);
      if (!!currentTabIndex) {
        dispatch(
          fetchKeywordAddDel({
            tabIndex: currentTabIndex,
            keywordObj: keywordObj,
            userId: 'ssss',
            reqTrackedType: keywordObj.tracked ? 'del' : 'add',
          })
        )
          .unwrap()
          .then((item) => {
            console.log('unwrap', item);
            setChangeGridObj({
              keyword: item.keywordObj?.keyword,
              group: item.keywordObj?.group,
              keywordObj: item.keywordObj,
            });
          });
      }
    },
    [dispatch, fetchKeywordAddDel, gridData]
  );

  // 아래 탭 클릭시 keywordData 요청처리
  const onClickTabHandler = useCallback(
    (tabObj) => {
      console.log('tabObj: ', tabObj);
      if (!!tabInfoData) {
        setSelectedTab(tabObj);
        setGridData(null);
        // 그리드 차트에 keyword 정보 넣기
        setTimeout(() => {
          setGridData(
            gridOption.resultOption(
              tabInfoData[tabObj.index]['keywordDataList'],
              registerdKeywordList,
              keywordGroupList,
              groupHandler,
              addDelHandler,
              tabObj.index
            )
          );
        }, 100);

        // // 기존 코드 추후 삭제처리
        // dispatch(
        //   fetchTabKeywordGridData({
        //     userId: 'SS',
        //     tabText: tabObj.text,
        //   })
        // );
        // //
        // setGridData(gridOption.resultOption(tabKeywordList, keywordGroupList, groupHandler, addDelHandler));
      }
    },
    [selectedTab, dispatch, fetchTabKeywordGridData, tabInfoData, registerdKeywordList, groupHandler, addDelHandler]
  );

  return (
    <div className="research-keyword">
      <ul className="research-tab">
        {tabInfoData?.length > 0 &&
          tabInfoData.map((tabObj, index) => (
            <li key={index}>
              <input
                type="radio"
                name="tabgroup2"
                id={`tab-${tabObj.index}`}
                className="research-tab-radio"
                checked={selectedTab === null ? false : tabObj.index === selectedTab.index ? true : false}
                onChange={() => onClickTabHandler(tabObj)}
                disabled={!!tabObj?.keywordDataList ? false : true}
              />
              <label htmlFor={`tab-${tabObj.index}`}>
                {`${tabObj.text}`}
                {`${!!tabObj?.keywordDataList ? `(${tabObj?.keywordDataList.length})` : ''}`}
                {/* {!tabObj?.keywordDataList && <FadeLoader />} */}
              </label>
            </li>
          ))}
      </ul>
      <div className="table-api-wrap">
        <div className="table-api">{gridData ? <GridAtom {...gridData} height="590px" /> : <NoData />}</div>
      </div>
    </div>
  );
};

export default ResultKeywordsBox;
